/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import * as angular from 'angular';

angular.module('CanvasWrapper').factory('InteractionHandleEvent', HandleEventFactory);
/**
 * There are actually two different types of objects that get passed here:
 * An IRenderer or a DisplayObject.
 * An IRenderer has a plugins field, but a DisplayObject does not.
 * So we use the plugins.events to determine if the object is a IRenderer or a DisplayObject
 * @returns {CanvasWrapper.Interaction.HandleEvent}
 * @memberOf CanvasWrapper.Interaction
 * @constructor
 */
function HandleEventFactory() {
	function handleEvent(displayNode) {
		if (!displayNode?.plugins?.events) {
			return displayNode;
		} else {
			return displayNode.events;
		}
	}
	return handleEvent;
}
